import { ContainerSection as GuestLandingPageSection } from './ContainerSection';

export default GuestLandingPageSection;
